<template>
    <form class="container ">
        <div class="form-group">
             <label>Type</label>
             <select type="text" v-model="type" class="form-control">
                <option value="event">Event</option>
                <option value="teamBuilding">Team building</option>
             </select>
         </div>
         <div class="form-group">
             <label>Title</label>
             <input type="text" class="form-control" v-model="title">
         </div>
         <div class="form-group">
             <label for="exampleInputPassword1">Description</label>
             <textarea type="text" rows="10" class="form-control" v-model="description" ></textarea>
         </div>
         <div class="form-group">
             <label >Image</label>
             <input type="file" class="form-control"  @change="onChangeFile" >
         </div>
         <div class="form-group">
             <label >Slider Image</label>
             <input type="file" class="form-control" name="file[]" @change="handleFileChange" multiple/>
         </div>   
         <div class="box" v-if="type== 'event'">
            <label >More informations</label>
            <div v-for="(row, index) in moreInfo" :key="index"  class="row">
                <div class="col">
                    <input type="text" v-model="row.key" class="form-control">
                </div>
                <div class="col">
                    <input type="text" v-model="row.value" class="form-control">
                </div>
                <div class="col-1">
                    <button type="button" @click="deleteRow(index)" class="btn btn-danger primary">-</button>
                </div>
            </div>
            <button type="button" class="btn btn-primary mt-2  mb-4 d-block" @click="addInfo" >+</button>
         </div>
         <button type="submit" class="btn btn-light me-2" @click.prevent="addEvent">Add</button>
         <button type="button" class="btn btn-light" @click ="$emit('cancel' , {})" >Cancel</button>
     </form> 
 </template>
 <script>
 
 import axios from 'axios'
 import APIs from "@/../config";
 export default{
     name: "AddEvent" ,
     data() {
         return {
            type:"event" , 
            moreInfo : [ {key : "" , value : ""}] , 
             title : "",
             description : "" , 
             selectedFile:"",
             selectedFiles: []
         }
     },
        methods : {
         onChangeFile(event) {
         this.selectedFiles.push(event.target.files[0])
         },
 
         handleFileChange(event) {
         for(let  i = 0 ; i < event.target.files.length ; i++)
             this.selectedFiles.push(event.target.files[i])
         // this.selectedFiles = event.target.files
 
         // console.log("all files", event.target.files.length)
         // console.log("one file", event.target.files[0])
         },
         changeType(){
            console.log(this.type)
         },
         addInfo() {
            console.log(this.moreInfo)
            this.moreInfo.push({key: "" , value : ""})
         }, 
         deleteRow(index){
            this.moreInfo.splice(index, 1)
         },
         addEvent(){
             const fd = new FormData()
 
             for(let i = 0; i < this.selectedFiles.length; i++) {
                 fd.append("images", this.selectedFiles[i]);
             }
             fd.append('title' , this.title)
             fd.append('description' , this.description)
             fd.append('type' , this.type)
             fd.append('moreInfo' , JSON.stringify(this.moreInfo))
 
             var get_token = localStorage.getItem('token')
             var user_id = localStorage.getItem('user_id')
             axios.post(`${APIs.API_URL}/event/${user_id}`, fd,{
                 headers: {
                 'Content-Type': 'multipart/form-data',
                 Authorization: `Bearer ${get_token}`
                 }
             })
             .then(()=> {
                  this.$swal.fire({
                     position: 'top-end',
                     icon: 'success',
                     title: "Updated",
                     showConfirmButton: false,
                     timer: 1500
                 });
                 this.$emit('refresh')
             })
             .catch((error) => {
                 this.$swal.fire({
                     position: 'top-end',
                     icon: 'error',
                     title: error.response.data.error,
                     showConfirmButton: false,
                     timer: 1500
                 });
             })
         }
     }
 }
 </script>
 